import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { ManageCartsActions } from '../actions';
import { CreateCartAction, CreateCartResponseObject } from '../state/cart-details.state';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { Store } from '@ngrx/store';
import { StorageService } from '../../../../SGRE-shared/services/storage.service';
import { SharedActions } from '../../../../SGRE-shared/store/shared-store/actions';

@Injectable()
export class CreateCartEffects {

  protected logger = inject(LoggerService);

  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private globalService: GlobalService,
    private storageService: StorageService,
    private store: Store,
  ) { }

  // Api Call : To Create a New Cart in the Saved-Carts List
  createCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ManageCartsActions.createCart),
      switchMap((action: CreateCartAction) => {
        return this.apiService.createNewSavedCart(action.paramsObject)
          .pipe(
            map((response: CreateCartResponseObject) => {
              if (response.status === 200) {
                return ManageCartsActions.createCartSuccess({ success: true });
              } else {
                return ManageCartsActions.createCartFailure({
                  error: tryNormalizeHttpError(new Error('Create Cart API failed'), this.logger)
                });
              }
            }),
            catchError((error) => of(
              ManageCartsActions.createCartFailure({
                error: tryNormalizeHttpError(error, this.logger)
              })
            ))
          );
      })
    )
  );

  loadMiniCartAndManageCarts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ManageCartsActions.loadMiniCartAndManageCarts),
      switchMap(() => {
        const paramsObject = {
          legalEntities: this.storageService?.defaultLegalEntity?.uid || null,
          fields: 'FULL',
          currentPage: 0,
          pageSize: 5
        };
        // Trigger Mini Cart api
        this.store.dispatch(SharedActions.loadCartsByLegalEntity(paramsObject));

        // Now, listen for the success of the loadCartsByLegalEntity action
        return this.actions$.pipe(
          ofType(SharedActions.loadCartsByLegalEntitySuccess),
          map(() => {
            this.globalService.loadManageCarts();
            return { type: 'NO_ACTION' }; // returning a dummy action
          }),
          take(1),
        );
      }),
    )
  );
}